<div class="wrapper loading-box" *ngIf="loadConfig || !delayPassed">
  <div>
    <img src="{{getAssets()?.logo}}" alt="" width="100px">
  </div>
  <img src="{{getAssets()?.loading}}" alt="" width="80px">
</div>
<router-outlet *ngIf="!loadConfig && delayPassed"></router-outlet>

